<template>
  <section class="closefriend-hero h-100">
    <b @click="slideBar()" :class="showSlideBar ? 'screen-overlay show' : 'screen-overlay'"></b>


    <customer-menu @menuClicked="slideBar()" :show-slide-bar="showSlideBar"></customer-menu>
    <header-menu :is-loading="isLoading" @slideMenu="slideBar()"></header-menu>
    <div class="container-fluid mt-3">
      <div class="row justify-content-center">
        <div class="col-12 px-2 px-md-4" style="max-width: 1200px;">
          <div class="mx-auto mb-3" style="max-width: 1200px;">
            <global-message></global-message>

            <!-- Header -->
            <div class="d-flex flex-wrap align-items-center justify-content-between mb-4 mt-2 px-1 gap-2">
              <div>
                <h5 class="text-white font-weight-700 mb-0 font-size-20">Bonus Content</h5>
                <span class="text-muted font-size-12">Exclusive media & posts from your creators</span>
              </div>
              <!-- Lock Status Filter -->
              <div class="bonus-filter-bar d-inline-flex align-items-center">
                <button type="button" 
                        class="bonus-filter-pill" 
                        :class="{ 'active': activeFilter === 'LOCKED' }" 
                        @click="setFilter('LOCKED')">
                  <i class="fa fa-lock me-1"></i> Locked
                </button>
                <button type="button" 
                        class="bonus-filter-pill" 
                        :class="{ 'active': activeFilter === 'UNLOCKED' }" 
                        @click="setFilter('UNLOCKED')">
                  <i class="fa fa-unlock me-1"></i> Unlocked
                </button>
              </div>
            </div>
          </div>
                  
                  <!-- post start -->
                  <!-- 3-column unified grid -->
                  <div class="content-grid" v-if="filteredContents.length">
                    <template v-for="(content, index) in filteredContents">
                      <div :key="'item-' + index"
                           class="grid-cell content-animate"
                           :style="{ animationDelay: index * 40 + 'ms' }">
                           
                        <!-- Pinned badge -->
                        <div v-if="content.pinned" class="grid-badge pinned-badge">📌</div>

                        <!-- LOCKED CONTENT -->
                        <template v-if="!content.cdnUrl">
                          <img style="filter: blur(10px); -webkit-user-drag: none; -webkit-touch-callout: none; user-select: none;" class="grid-media" src="@/assets/images/stella/card-bg.png" loading="lazy" @dragstart.prevent>
                          <div class="content-locked-overlay" style="cursor: pointer;" @click.stop="unLock(index)">
                            <img src="@/assets/images/stella/swipe-lock.png" style="width:32px; margin-bottom:8px; -webkit-user-drag: none;">
                            <button class="cp-btn-primary font-size-13 px-4 py-2">
                              {{ content.price === 0 ? 'View Free' : ('Unlock • $' + content.price) }}
                            </button>
                          </div>
                        </template>

                        <!-- UNLOCKED CONTENT -->
                        <template v-else>
                          <div class="position-relative h-100 w-100" v-if="content.type === CONTENT_TYPE_IMAGE || content.type === CONTENT_TYPE_VIDEO" @dragstart.prevent style="user-select: none; -webkit-touch-callout: none; overflow: hidden; border-radius: 16px;">
                            <!-- IMAGE -->
                            <img v-if="content.type === CONTENT_TYPE_IMAGE" :src="index <= allowedIndex ? content.cdnUrl : ''" class="grid-media" style="-webkit-user-drag: none; -webkit-touch-callout: none; user-select: none;" @click="$refs.imageView.show(content.cdnUrl, getUser, content.influencer, content.description)" loading="lazy">
                            
                            <template v-else-if="content.type === CONTENT_TYPE_VIDEO">
                              <video class="grid-media" :src="index <= allowedIndex ? content.cdnUrl : ''" preload="none" muted controlsList="nodownload" oncontextmenu="return false;" @click="showVideo($event, content.cdnUrl, content.influencer, content.description)"></video>
                              <div class="play-icon" @click="showVideo($event, content.cdnUrl, content.influencer, content.description)">▶</div>
                            </template>
                            
                            <!-- WATERMARK -->
                            <div class="watermark-container" v-if="content.type === CONTENT_TYPE_IMAGE || content.type === CONTENT_TYPE_VIDEO" :style="content.type === CONTENT_TYPE_VIDEO ? 'pointer-events: none;' : 'pointer-events: auto;'" @click="content.type === CONTENT_TYPE_IMAGE ? $refs.imageView.show(content.cdnUrl, getUser, content.influencer, content.description) : null"></div>
                          </div>
                          
                          <!-- FILE -->
                          <div v-else class="file-tile" @click="$refs.pdfView.show(content)">
                            <img src="@/assets/images/download.png" style="width:40px;height:40px;opacity:0.8;">
                            <div class="file-name">{{ content.ext }}</div>
                          </div>
                        </template>

                        <!-- Permanent Creator & Description Overlay -->
                        <div class="grid-info-overlay d-flex flex-column text-left w-100" v-if="content.influencer">
                          <div class="d-flex align-items-center justify-content-between">
                            <div class="d-flex align-items-center" style="gap: 10px;">
                              <message-avatar :user-id="content.influencer.id" size="34px" class="shadow-sm" style="border: 2px solid rgba(229, 59, 185, 0.4); border-radius: 50%; display: inline-flex; pointer-events: auto;" />
                              <div class="text-white font-weight-bold font-size-14" style="text-shadow: 0 1px 4px rgba(0,0,0,0.9); pointer-events: auto;">{{ content.influencer.name }}</div>
                            </div>
                            <!-- Right Side Info: Price -->
                            <div class="d-flex flex-column align-items-end flex-shrink-0" style="pointer-events: auto;">
                              <div v-if="content.price !== 0" class="stella-price-tag">
                                ${{ content.price }}
                              </div>
                              <div v-else class="stella-price-tag free-tag">
                                Free
                              </div>
                            </div>
                          </div>
                          <div v-if="content.description" class="text-white mt-2 font-size-12 hover-desc-text" :title="content.description">
                            {{ content.description }}
                          </div>
                        </div>

                        <!-- Permanent Bottom Overlay: Actions -->
                        <div class="grid-bottom-overlay d-flex align-items-center justify-content-between w-100" v-if="content.influencer">
                          <!-- Left: Like Pill Button -->
                          <button class="btn p-0 stella-like-pill" @click.stop="likeIt(index)">
                            <i class="fa fa-heart" :style="{ color: content.liked ? '#E53BB9' : '#ffffff', fontSize: '16px', transition: 'color 0.2s, transform 0.2s', filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.5))' }" :class="{ 'liked-bounce': content.liked }"></i>
                            <span v-if="content.likedCount > 0" class="text-white font-size-12 font-weight-bold ms-1" style="text-shadow: 0 1px 3px rgba(0,0,0,0.8);">{{ content.likedCount }}</span>
                          </button>
                          
                          <!-- Right: Action Buttons Group (Never overlapping) -->
                          <div class="d-flex align-items-center stella-action-group">
                            <!-- Custom Request -->
                            <button class="btn stella-circle-action-btn" @click.stop="submitCustomRequest(content.influencer)" title="Custom Request">
                              <span style="font-size: 16px;">✨</span>
                            </button>
                            <!-- Tip Creator -->
                            <button class="btn stella-circle-action-btn" @click.stop="goToTip(content.influencer)" title="Send a Tip">
                              <span style="font-size: 16px;">🎁</span>
                            </button>
                            <!-- Direct Message -->
                            <button class="btn stella-circle-action-btn" @click.stop="$router.push({name: 'CustomerDirectMessage', params: {customerId: content.influencer.id}})" title="Direct Message">
                              <span style="font-size: 16px;">💬</span>
                            </button>
                          </div>
                        </div>

                      </div>
                    </template>
                  </div>
                  <!-- post end -->

                  <!-- Empty State -->
                  <div v-else-if="!isLoading" class="bonus-empty-state text-center py-5 my-3">
                    <div class="bonus-empty-icon mb-3">
                      <i v-if="activeFilter === 'LOCKED'" class="fa fa-lock" style="font-size: 38px; color: rgba(255, 255, 255, 0.25);"></i>
                      <i v-else class="fa fa-unlock-alt" style="font-size: 38px; color: rgba(255, 255, 255, 0.25);"></i>
                    </div>
                    <h5 class="text-white font-weight-600 mb-2">
                      {{ activeFilter === 'LOCKED' ? 'No locked bonus content' : 'No unlocked bonus content yet' }}
                    </h5>
                    <p class="text-muted font-size-14 mb-0" style="max-width: 380px; margin: 0 auto;">
                      {{ activeFilter === 'LOCKED' ? 'All available bonus content has already been unlocked!' : 'Unlock exclusive posts from your favorite creators to view them here.' }}
                    </p>
                  </div>

        </div>
      </div>
    </div>

          <infinite-loading v-if="showPendingCustomRequests" :identifier="infiniteId" @infinite="loadData">
            <div slot="no-more"></div>
            <div slot="no-results"></div>
          </infinite-loading>

          <model-confirm-purchase ref="pay" 
            :title="(selectedContent && selectedContent.price === 0) ? 'Free Access' : 'Confirm your purchase'" 
            :text="confirmPurchaseText"
            :confirm-btn-txt="(selectedContent && selectedContent.price === 0) ? 'Get Access' : 'Pay'" 
            :isLoading="isLoading" @confirm="pay()" />
            
          <model-image-view ref="imageView" />
          <model-video-view ref="videoView" />
          <model-pdf-view ref="pdfView" />
          <!-- Custom request -->
          <model-customer-custom-request-submit ref="customRequestConfirm" @savedCustomRequest="(customRequest) => {
            $refs.customRequestDone.show(customRequest);
          }" @submittedCustomRequestOption="(customRequest) => {
            $refs.customRequestOption.show(customRequest, user.id);
          }" />

          <model-customer-custom-request-option-info ref="customRequestOption" @savedCustomRequestOption="(customRequest) => {
            if (customRequest.status === CR_STATUS_ACCEPTED) {
              $refs.customRequestAccepted.show(customRequest);
            } else if (customRequest.status === CR_STATUS_READY) {
              $refs.customRequestDone.show(customRequest, true);
            }
          }" @back="() => {
            $refs.customRequestConfirm.simpleShow();
          }" />

          <model-customer-custom-request-accepted ref="customRequestAccepted" />

          <model-customer-custom-request-done ref="customRequestDone" @doneCustomRequest="() => {
          }" />

          <stripe-checkout v-if="show" ref="checkoutRef" :pk="pk" :sessionId="sessionId"></stripe-checkout>
  </section>
</template>

<script>

import HeaderMenu from "@/components/module/influencer/shared/HeaderMenu";
import CustomerMenu from "@/components/module/customer/shared/CustomerMenu";
import GlobalMessage from "@/components/module/shared/GlobalMessage";
import { SERVICE_CONTENT, SERVICE_IDENTIY, SERVICE_PAYMENT } from "@/properties/micro-service";
import ModelConfirmPurchase from "@/components/module/customer/shared/ModelBasic";
import { StripeCheckout } from "@vue-stripe/vue-stripe";
import { igValidationMixin } from "@/mixin/ig-validation-mixin";
import ModelImageView from "@/components/module/shared/ModelImageView";
import ModelVideoView from "@/components/module/shared/ModelVideoView";
import ModelPdfView from "@/components/module/shared/ModelPdfView";
import MessageAvatar from "@/components/module/shared/direct-message/MessageAvatar";
import { timeSince } from "@/common/datetime-service";
import { mapActions, mapGetters } from "vuex";
import InfiniteLoading from "vue-infinite-loading";
import ModelCustomerCustomRequestConfirm
  from "@/components/module/customer/custom-request/ModelCustomerCustomRequestConfirm";
import ModelCustomerCustomRequestDone from "@/components/module/customer/custom-request/ModelCustomerCustomRequestDone";
import ModelCustomerCustomRequestSubmit
  from "@/components/module/customer/custom-request/ModelCustomerCustomRequestSubmit";
import { CONTENT_TYPE_IMAGE, CONTENT_TYPE_VIDEO } from "@/properties/content-type";
import ModelCustomerCustomRequestOptionInfo
  from "@/components/module/customer/custom-request/ModelCustomerCustomRequestOptionInfo";
import PendingCustomRequests from "@/components/module/customer/shared/PendingCustomRequests";
import CustomerPwaActionBar from "@/components/module/customer/shared/CustomerPwaActionBar";
import { isUserActive } from "@/common/comm-service";
import { geDecodedToken, getTokenExp, isRole, isTokenExpired } from "@/common/http-common";
import { ACCESS_TOKEN } from "@/properties/close-friend";
import { CR_STATUS_ACCEPTED, CR_STATUS_READY } from "@/properties/custom-request-status";
import ModelCustomerCustomRequestAccepted
  from "@/components/module/customer/custom-request/ModelCustomerCustomRequestAccepted";
import titleMixin from "../../../../mixin/title-mixin";
import {
  BONUS_CONTENT,
  paymentCancelled,
  paymentInProgress,
  paymentOtherStatus,
  paymentPaid
} from "@/common/analytics-service";

export default {
  name: 'CustomerBonusContentList',
  mixins: [igValidationMixin, titleMixin],
  props: ['id', 'query'],
  title: 'Customer bonus content',
  components: {
    HeaderMenu,
    CustomerPwaActionBar,
    CustomerMenu,
    GlobalMessage, ModelConfirmPurchase, InfiniteLoading,
    StripeCheckout, ModelImageView, ModelVideoView, MessageAvatar,
    ModelCustomerCustomRequestConfirm,
    ModelCustomerCustomRequestDone,
    ModelCustomerCustomRequestSubmit,
    ModelCustomerCustomRequestOptionInfo,
    PendingCustomRequests,
    ModelCustomerCustomRequestAccepted,
    ModelPdfView
  },
  data() {
    return {
      user: {},
      contentId: [],
      isSubmit: false,
      isVideo: false,
      contents: [],
      contentId: [],
      contentIndex: null,
      userIG: '',

      pageNumber: 0,
      noOfItems: 10,

      //Strip
      pk: "",
      sessionId: "",
      show: false,
      confirmPurchaseText: '',
      tapped: false,
      isInvalidIG: false,
      showPendingCustomRequests: false,

      CONTENT_TYPE_IMAGE,
      CONTENT_TYPE_VIDEO,

      CR_STATUS_ACCEPTED,
      CR_STATUS_READY,
      videoElementForPause: null,
      allowedIndex: 5,
      staggerInterval: null,
      activeFilter: 'LOCKED',
      infiniteId: +new Date()
    }
  },
  computed: {
    filteredContents() {
      if (this.activeFilter === 'LOCKED') {
        return this.contents.filter(c => !c.cdnUrl);
      } else if (this.activeFilter === 'UNLOCKED') {
        return this.contents.filter(c => !!c.cdnUrl);
      }
      return this.contents;
    },
    selectedContent() {
      if (this.contentIndex !== null && this.filteredContents[this.contentIndex]) {
        return this.filteredContents[this.contentIndex];
      }
      return null;
    },
    lockedContents() {
      return this.contents.filter(c => !c.cdnUrl);
    },
    unlockedMediaContents() {
      return this.contents.filter(c => c.cdnUrl && (c.type === this.CONTENT_TYPE_IMAGE || c.type === this.CONTENT_TYPE_VIDEO));
    },
    unlockedFileContents() {
      return this.contents.filter(c => c.cdnUrl && c.type !== this.CONTENT_TYPE_IMAGE && c.type !== this.CONTENT_TYPE_VIDEO);
    }
  },
  mounted() {
    this.staggerInterval = setInterval(() => {
      if (this.contents && this.allowedIndex < this.contents.length) {
        this.allowedIndex += 1;
      }
    }, 100);
  },
  beforeDestroy() {
    if (this.staggerInterval) {
      clearInterval(this.staggerInterval);
    }
  },
  created() {
    if (this.$route.query.status === 'success') {
      if (this.$route.query.clientReferenceId) {
        let clientReferenceId = this.$route.query.clientReferenceId;
        let URL = `${SERVICE_PAYMENT}/api/v1/stripe/transactions/${clientReferenceId}`;
        this.putData(URL, {}, (data) => {
          this.fetchData();
          if (this.$route.query.contentId) {
            let contentId = this.$route.query.contentId;
            this.user = this.getUser();
            let url = `${SERVICE_CONTENT}/api/v1/customers/${this.user.id}/content/${contentId}`;
            this.getData(url, (page) => {
              if (!page.empty) {
                this.contentId.push(page);
                if (page.type === "IMAGE") {
                  this.$nextTick(() => {
                    this.$refs.imageView.show(page.cdnUrl);
                  })
                  //this.$refs.imageView.show(page.cdnUrl);
                }
                else if (page.type === "VIDEO") {
                  this.showVideo(null, page.cdnUrl);
                }
                else if (page.type === "APPLICATION") {
                  this.$nextTick(() => {
                    this.$refs.pdfView.show(page);
                  })
                }
              }
            });
          }
        }, (error) => {
          // this.$router.replace({ name: 'Platform', params: { urlPrefix } });
        });
      }
    } else if (this.$route.query.status === 'failure') {
      this.setMessage('PAYMENT.FAILED');
      this.fetchData();
    }
    else {
      this.fetchData();
    }
    const currentUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
    window.history.replaceState({ path: currentUrl }, '', currentUrl);
  },
  methods: {
    ...mapGetters(['getUser', 'getCustomRequestInfluencer', 'getCustomRequestIndex', 'getPayInfluencer']),
    ...mapActions(['pushGlobalError', 'clearGlobalMessages', 'setGlobalMessages', 'setRedirectedFrom', 'setUser', 'setPayInfluencer', 'setInvitee', 'setMessage']),
    fetchData() {
      this.setRedirectedFrom(null);
      this.checkTokenValidity(() => {
        let tokenExp = getTokenExp(ACCESS_TOKEN);
        if (tokenExp && !isTokenExpired(ACCESS_TOKEN) && !isRole('INFLUENCER')) {
          if (!this.getUser()) {
            let customerId = geDecodedToken(ACCESS_TOKEN).id;
            let url = `${SERVICE_IDENTIY}/api/v1/customers/${customerId}`;
            this.getData(url, (customer) => {
              this.setUser(customer);
              this.onCreated();
            });
          } else {
            this.onCreated();
          }
        } else {
          this.setRedirectedFrom(this.$route.path);
          this.$router.replace({ name: 'LoginMobile' });
        }
      }, true);
    },
    onCreated() {
      this.showPendingCustomRequests = true;
      this.user = this.getUser();
      if (this.$route.query.status === 'cancelled') {
        paymentCancelled(this, BONUS_CONTENT, this.getPayInfluencer());
        let clientReferenceId = this.$route.query.clientReferenceId;
        let URL = `${SERVICE_PAYMENT}/api/v1/stripe/checkout/cancel/${clientReferenceId}`
        this.postUnsecureData(URL, {}, (data) => {
          this.showMessage('PAYMENT.CANCELLED');
        });
      } else if (this.$route.query.status === 'success') {
        paymentPaid(this, BONUS_CONTENT, this.getPayInfluencer());
        this.showMessage('PAYMENT.SUCCESSFUL');
      } else if (this.$route.query.status) {
        paymentOtherStatus(this, this.$route.query.status, BONUS_CONTENT, this.getPayInfluencer());
      }
      if (this.$route.query.saved) {
        this.showMessage('SAVED.SUCCESSFULLY');
      }
      this.showSelectedCustomRequest();
    },
    showMessage(msgCode) {
      this.setMessage(msgCode);
      this.scrollToGlobalError();
    },
    timeSince,
    confirmIG() {
      this.isInvalidIG = !this.isInvalidIG;
      /*this.getData(`${SERVICE_IDENTIY}/api/v1/customers/${this.getUser().id}/invalidIg`, (isInvalidIg) => {
        if (isInvalidIg) {
          this.isInvalidIG = isInvalidIg;
        }
      });*/
    },
    showSelectedCustomRequest() {
      console.log(`showSelectedCustomRequest - inside with value ${this.getCustomRequestInfluencer()}`);
      this.$nextTick(() => {
        if (this.getCustomRequestInfluencer() != null) {
          this.submitCustomRequest(this.getCustomRequestInfluencer())
          if (isUserActive(this.getCustomRequestInfluencer())) {
            console.log('showSelectedCustomRequest - show');
            if (this.getCustomRequestIndex() != null) {
              this.$refs.customRequestConfirm.chosenCustomRequestOption(this.getCustomRequestIndex());
            } else {
              this.$refs.customRequestConfirm.chosenCustomRequest();
            }
          }
        }
      })
    },
    submitCustomRequest(influencer) {
      if (isUserActive(influencer)) {
        this.$refs.customRequestConfirm.show(influencer.id, this.user.id, influencer.customRequestMinPrice);
      }
    },
    setFilter(filter) {
      if (this.activeFilter === filter) return;
      this.activeFilter = filter;
      this.pageNumber = 0;
      this.contents = [];
      this.infiniteId += 1;
    },
    loadData($state) {
      let url = `${SERVICE_CONTENT}/api/v1/customers/${this.user.id}/content/page?pageNumber=${this.pageNumber}&numberOfItems=${this.noOfItems}&status=${this.activeFilter}`;
      this.getData(url, (page) => {
        if (!page.empty) {
          const items = (page.content || []).filter(c => {
            if (this.activeFilter === 'LOCKED') return !c.cdnUrl;
            if (this.activeFilter === 'UNLOCKED') return !!c.cdnUrl;
            return true;
          });
          this.contents.push(...items);
          this.pageNumber += 1;
          $state.loaded();
        } else {
          $state.complete();
          console.log('complete');
        }
        if (this.pageNumber === 0) {
          this.initIGValidity();
        }
        this.setUpTapEventForMobile();
      });
    },

    setUpTapEventForMobile() {
      if (this.isMobile()) {
        this.$nextTick(() => {
          for (let i = 0; i < this.contents.length; i++) {
            let video = document.getElementById(`video${i}`);
            if (video) {
              video.addEventListener('touchstart', (e) => {
                if (!this.tapped) { //if tap is not set, set up single tap
                  this.tapped = setTimeout(() => {
                    this.tapped = null
                    //insert things you want to do when single this.tapped
                  }, 300);   //wait 300ms then run single click code

                } else {    //this.tapped within 300ms of last tap. double tap
                  clearTimeout(this.tapped); //stop single tap callback
                  this.tapped = null
                  //insert things you want to do when double tapped
                  let id = e.target.id;
                  let index = id.substring(5, id.length);
                  this.showVideo(e, this.contents[index].cdnUrl);
                }
                // e.preventDefault(); //This blocks scrolling
              });

            }
          }
        });
      }
    },
    unLock(index) {
      this.contentIndex = index;
      let target = this.filteredContents[this.contentIndex] || this.contents[this.contentIndex];
      if (!target) return;
      let price = target.price;
      if (price === 0) {
        this.confirmPurchaseText = `Get free access to this content`;
      } else {
        this.confirmPurchaseText = `You will be charged $${price}`;
      }
      this.$refs.pay.show();
    },
    likeIt(index) {
      let content = this.filteredContents[index] || this.contents[index];
      if (!content) return;
      content.liked = !content.liked;
      if (content.liked) {
        ++content.likedCount;
      } else {
        --content.likedCount;
      }
      let URL = `${SERVICE_CONTENT}/api/v1/customers/${this.user.id}/content/${content.id}?liked=${content.liked}`;
      this.patchData(URL, {}, (contentLike) => {
      });
    },
    showVideo(event, url, influencer = null, description = null) {
      this.$refs.videoView.show(url, influencer, description);
      if (event && !this.isMobile()) {
        event.preventDefault();
      }
    },
    pay() {
      let target = this.selectedContent || this.contents[this.contentIndex];
      if (!target) return;
      let URL = `${SERVICE_CONTENT}/api/v1/customers/${this.user.id}/content/${target.id}/purchase`;
      let influencer = target.influencer;
      this.setPayInfluencer(influencer);

      this.postData(URL, {}, (stripeCheckoutData) => {
        this.$refs.pay.hide();

        let otherData = stripeCheckoutData.othersData;
        let status = stripeCheckoutData.status;
        this.pk = otherData.pk;
        this.sessionId = stripeCheckoutData.req.id;

        if (status === 'Success') {
          paymentPaid(this, BONUS_CONTENT, influencer);
          if (stripeCheckoutData.req.contentId) {
            let contentId = stripeCheckoutData.req.contentId;
            this.user = this.getUser();
            let url = `${SERVICE_CONTENT}/api/v1/customers/${this.user.id}/content/${contentId}`;
            this.getData(url, (page) => {
              if (!page.empty) {
                this.contentId.push(page);
                if (page.type === "IMAGE") {
                  this.$nextTick(() => {
                    this.$refs.imageView.show(page.cdnUrl);
                  })
                  //this.$refs.imageView.show(page.cdnUrl);
                }
                else if (page.type === "VIDEO") {
                  this.showVideo(null, page.cdnUrl);
                }
                else if (page.type === "APPLICATION") {
                  this.$nextTick(() => {
                    this.$refs.pdfView.show(page);
                  })
                }
              }
            });
          }
          let maxItems = this.pageNumber === 0 ? this.noOfItems : (this.pageNumber * this.noOfItems);
          let url = `${SERVICE_CONTENT}/api/v1/customers/${this.user.id}/content/page?pageNumber=0&numberOfItems=${maxItems}&status=${this.activeFilter}`;
          this.getData(url, (page) => {
            this.showMessage("PAYMENT.SUCCESSFUL");
            if (!page.empty) {
              this.contents = (page.content || []).filter(c => {
                if (this.activeFilter === 'LOCKED') return !c.cdnUrl;
                if (this.activeFilter === 'UNLOCKED') return !!c.cdnUrl;
                return true;
              });
              this.setUpTapEventForMobile();
            }
          });
        } else if (status === 'InProgress') {
          if (otherData.offlineCheckoutError) {
           this.pushGlobalError(otherData.offlineCheckoutError.trim());
          }
          setTimeout(() => {
            this.show = true;
            this.isLoading = true;
            this.$nextTick(() => {
              this.$refs.checkoutRef.redirectToCheckout();
            });
          }, 2000);
        } else {
          paymentOtherStatus(this, status, BONUS_CONTENT, influencer);
        }
      }, (errorData) => {
        this.isLoading = false;
        this.clearGlobalMessages();
        if (errorData && errorData.error) {
          this.pushGlobalError(errorData.error);
        } else if (errorData && errorData.message) {
          this.pushGlobalError(errorData.message);
        } else {
          this.setGlobalMessages(errorData);
        }
        this.scrollToGlobalError();
      });
    },
    goToTip(influencer) {
      this.setInvitee(influencer);
      this.$router.push({ name: 'TipPayment', query: { donate: true } });
    },
    slideBar() {
      this.showSlideBar = !this.showSlideBar;
    },
    handlePlay(index) {
      console.log('Play event triggered for index:', index);
      if (this.currentPlayingIndex !== null && this.currentPlayingIndex !== index) {
        const previousVideo = this.$refs[`video_${this.currentPlayingIndex}`]?.[0];
        if (previousVideo) {
          previousVideo.pause();
        }
      }
      this.currentPlayingIndex = index;
    }
  }
}

</script>

<style scoped>
@keyframes fadeSlideIn {
  from { opacity: 0; transform: translateY(16px); }
  to   { opacity: 1; transform: translateY(0); }
}
.content-animate { animation: fadeSlideIn 0.4s ease both; }

/* Responsive Unified Grid */
.content-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  margin-top: 12px;
}

@media (min-width: 600px) {
  .content-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }
}

@media (min-width: 992px) {
  .content-grid {
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    gap: 20px;
  }
}

.grid-cell {
  position: relative;
  overflow: hidden;
  cursor: pointer;
  background: rgba(18, 18, 22, 0.85);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  aspect-ratio: 4 / 3;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 18px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.45);
  transition: transform 0.25s ease, border-color 0.25s ease;
}

@media (min-width: 768px) {
  .grid-cell {
    aspect-ratio: 1 / 1;
  }
}

.grid-cell:hover {
  transform: translateY(-2px);
  border-color: rgba(229, 59, 185, 0.4);
}

.grid-media {
  position: absolute;
  top: 0; left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  pointer-events: none;
}

.grid-badge {
  position: absolute;
  z-index: 6;
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 8px;
  pointer-events: none;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(8px);
}
.pinned-badge { top: 12px; left: 12px; }

.stella-price-tag {
  background: linear-gradient(90deg, #F3DA6B 0%, #E53BB9 100%);
  color: #fff;
  font-weight: 700;
  font-size: 13px;
  padding: 4px 12px;
  border-radius: 20px;
  box-shadow: 0 2px 10px rgba(229, 59, 185, 0.4);
  letter-spacing: 0.3px;
}

.stella-price-tag.free-tag {
  background: rgba(112, 213, 194, 0.2);
  border: 1px solid #70D5C2;
  color: #70D5C2;
  box-shadow: 0 2px 8px rgba(112, 213, 194, 0.3);
}

.content-locked-overlay {
  position: absolute;
  inset: 0;
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

.grid-info-overlay {
  position: absolute;
  top: 0; left: 0; right: 0;
  padding: 14px;
  background: linear-gradient(to bottom, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.4) 60%, transparent 100%);
  pointer-events: none;
  z-index: 4;
}

.hover-desc-text {
  opacity: 0.95;
  text-shadow: 0 1px 3px rgba(0,0,0,0.9);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 38px;
  line-height: 1.4;
  pointer-events: auto;
}

.grid-bottom-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 12px 14px;
  z-index: 5;
  pointer-events: none;
  background: linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.4) 60%, transparent 100%);
}

.stella-like-pill {
  background: rgba(14, 14, 18, 0.75);
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 50px;
  padding: 6px 14px;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  display: inline-flex;
  align-items: center;
  gap: 6px;
  pointer-events: auto;
  outline: none !important;
  box-shadow: none !important;
  transition: all 0.2s ease;
}

.stella-like-pill:hover,
.stella-like-pill:active {
  background: rgba(229, 59, 185, 0.2);
  border-color: #E53BB9;
}

.stella-action-group {
  gap: 8px;
  flex-shrink: 0;
  pointer-events: auto;
}

.stella-circle-action-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(14, 14, 18, 0.75);
  border: 1px solid rgba(255, 255, 255, 0.16);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  transition: all 0.2s ease;
  outline: none !important;
  box-shadow: none !important;
}

.stella-circle-action-btn:hover,
.stella-circle-action-btn:active {
  background: rgba(229, 59, 185, 0.25);
  border-color: #E53BB9;
  transform: scale(1.12);
  box-shadow: 0 0 12px rgba(229, 59, 185, 0.45);
}

.play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 28px;
  color: rgba(255,255,255,0.95);
  text-shadow: 0 2px 8px rgba(0,0,0,0.6);
  pointer-events: none;
  z-index: 2;
}

.file-tile {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #18181c;
}

.file-name {
  margin-top: 8px;
  font-size: 11px;
  color: #aaa;
  text-transform: uppercase;
  font-weight: 600;
}

.watermark-container {
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  overflow: hidden;
  opacity: 0.18;
  z-index: 10;
  background-repeat: repeat-x;
  background-size: 150px;
  background-position: center;
  transform: rotate(-25deg);
}

.bonus-filter-bar {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 30px;
  padding: 4px;
  gap: 4px;
}

.bonus-filter-pill {
  border: 1px solid transparent;
  border-radius: 24px;
  padding: 6px 18px;
  font-size: 13px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.65);
  background: transparent;
  transition: all 0.25s ease;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  user-select: none;
  outline: none !important;
}

.bonus-filter-pill:hover:not(.active) {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.08);
}

.bonus-filter-pill.active {
  background: linear-gradient(135deg, rgba(229, 59, 185, 0.3), rgba(112, 213, 194, 0.2));
  border-color: #E53BB9;
  color: #ffffff;
  font-weight: 600;
  box-shadow: 0 0 14px rgba(229, 59, 185, 0.35);
}

.bonus-empty-state {
  background: rgba(20, 20, 24, 0.6);
  border: 1px dashed rgba(255, 255, 255, 0.12);
  border-radius: 20px;
  padding: 48px 24px;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}
</style>
